"use client"

import { usePathname } from "next/navigation"
import { useEffect } from "react"
import BrewMenuNavigation from "../BrewMenuNavigation"
import MarketingNavigation from "../MarketingNavigation"
import OperationsNavigation from "../OperationsNavigation"
import OrganizationNavigation from "../OrganizationNavigation"
import { NavigationViews, rootNavigationState } from "../state/rootNavigationState"

const CurrentNavigation: React.FC = () => {
    const pathName = usePathname()

    const currentNavView = rootNavigationState((state) => state.currentNavView)
    const setCurrentNavView = rootNavigationState((state) => state.setCurrentNavView)

    useEffect(() => {
        if (pathName === "/dashboard" && currentNavView !== NavigationViews.Org) {
            setCurrentNavView(NavigationViews.Org)
        }
    }, [currentNavView])

    switch (currentNavView) {
        case NavigationViews.Org:
            return <OrganizationNavigation />
        case NavigationViews.BMA:
            return <BrewMenuNavigation />
        case NavigationViews.PP:
            return <OperationsNavigation />
        case NavigationViews.MMB:
            return <MarketingNavigation />
        default:
            return <OrganizationNavigation />
    }
}

export default CurrentNavigation
